import { render, staticRenderFns } from "./RinvRL_Rows_Action.vue?vue&type=template&id=0c5664c7"
import script from "./RinvRL_Rows_Action.vue?vue&type=script&lang=js"
export * from "./RinvRL_Rows_Action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports